<div *ngIf="!termsAndCondAccepted" class="banner" id="banner">
    <div class="text"> We've updated our RewardShip Program
        <span (click)="openTermsConditionsDialog($event)" class="text-link">Terms and Conditions</span>, effective
        October 23, 2023. By continuing, you agree to the updated terms.
    </div>
    <button (click)="acceptTermsConditions()" mat-raised-button>Continue<span class="material-symbols-outlined">chevron_right</span>
    </button>
</div>
<div class="reward-ship white-sheet-content content-disabled">
    <div class="ups-page-header">
        <h1 class="page-title">{{'RewardShip'|translate}}</h1>
    </div>

    <div class="rewards">
        <div class="reward-wrapper">
            <div class="reward">
                <div class="credit-amount">${{header?.AvailableSum|number}}</div>
                <div class="credit-type">{{'RedeemableCredits'|translate}}</div>
                <div class="credit-message">{{'ApplyCreditsToShipment'|translate}}</div>
                <div class="credit-action">
                    <button type="button" mat-raised-button (click)="redeemConfirmation()">
                        {{'RedeemNow'|translate}}
                    </button>
                </div>
            </div>
        </div>
        <div class="reward-wrapper">
            <div class="reward">
                <div class="credit-amount">${{header?.PotentialSum}}</div>
                <div class="credit-type">{{'CreditsinProgress'|translate}}</div>
                <!-- <div class="credit-message">{{'ExpiredOnDueDateOfCurrentInvoice'|translate}}</div> -->
                <div class="credit-action"></div>
            </div>
        </div>
        <div class="reward-wrapper">
            <div class="reward">
                <div class="credit-amount">${{header?.RedeemedSum}}</div>
                <div class="credit-type">{{ 'TotalRedeemedCredits'|translate }}</div>
                <!-- [MV3-3664] Current date should be displayed as MM/DD/YYYY (ex: 05/07/2019) instead of MM/DD/YY -->
                <div class="credit-message">As of {{ currentDate }}</div>
                <div class="credit-action"></div>
            </div>
        </div>
    </div>

    <div class="features">
        <div class="feature-wrapper">
            <div class="feature">
                <div class="feature-icon" >
                <img src="../../../assets/icons/help.svg" class="" alt="">
                </div>               
                <div class="feature-title">{{'ShipMoreSaveMore'|translate}}</div>
                <div class="feature-message">{{'ShipMoreSaveMore_Msg'|translate}}</div>
            </div>
        </div>
        <div class="feature-wrapper">
            <div class="feature">
                <!-- <div class="feature-icon" [inlineSVG]="'../../../assets/icons/help.svg'"></div> -->
                <div class="feature-icon" >
                    <img src="../../../assets/icons/help.svg" alt="">
                    </div> 
                <div class="feature-title">{{'HowItWorks'|translate}}</div>
                <div class="feature-message">{{'HowItWorks_Msg'|translate}}</div>
            </div>
        </div>
        <div class="feature-wrapper">
            <div class="feature">
                <!-- <div class="feature-icon" [inlineSVG]="'../../../assets/icons/help.svg'"></div> -->
                <div class="feature-icon" >
                    <img src="../../../assets/icons/help.svg" alt="">
                    </div> 
                <div class="feature-title">{{'BoostYourRewards'|translate}}</div>
                <div class="feature-message">{{'BoostYourRewards_Msg'|translate}}</div>
            </div>
        </div>
    </div>

    <div class="grid-title">{{'RewardShipCreditHistory'|translate}}</div>
    <ng-container [ngTemplateOutlet]="rewardShipTable"></ng-container>

    <div class="contact">
        <div class="title">
            {{'HaveQuestions'|translate}}?
        </div>
        <div class="message">
            {{'ContactUsAt'|translate}} <a href="mailto:accounting@parcelpro.com">accounting&#64;parcelpro.com</a>
        </div>
    </div>
    <div class="rules">
        {{'ProgramRulesApply.MessagePart1'|translate}} <a href="javascript:;" (click)="openTermsConditionsDialog($event)">{{'ProgramRulesApply.Link'|translate}}</a>
        {{'ProgramRulesApply.MessagePart2'|translate}}.
    </div>
</div>

<ng-template #rewardShipTable>
    <div class="table-wrapper" [class.responsive-table]="dtOptions.responsive">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe">
            <thead>
            <tr>
                <th class="all trigger-column"></th>
                <th class="text-center">{{'InvoiceId'|translate}}</th>
                <th class="text-center">{{'ActivityDate'|translate}}</th>
                <th class="text-center">{{'DueDate'|translate}}</th>
                <th class="text-center">{{'DatePaid'|translate}}</th>
                <th class="text-center">{{'CreditsinProgress'|translate}}</th>
                <th class="text-center">{{'AvailableCredits'|translate}}</th>
                <th class="text-center">{{'Redeemed'|translate}}</th>
                <th class="text-center">{{'Forfeited'|translate}}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let reward of asyncRewards | async | paginate:paginate">
                <td class="trigger-cell"></td>
                <td class="text-center">{{ reward.InvoiceID }}</td>
                <td class="text-center">{{ reward.ActivityDate | date:'MM/dd/yyyy' }}</td>
                <td class="text-center">{{ reward.DueDate }}</td>
                <td class="text-center">{{ reward.PaidDate }}</td>
                <td class="text-center">{{ reward.PotentialPoints }}</td>
                <td class="text-center">{{ reward.AvailablePoints }}</td>
                <td class="text-center">{{ reward.RedeemedPoints }}</td>
                <td class="text-center">{{ reward.ForfeitedPoints }}</td>
            </tr>
            </tbody>
        </table>

        <pagination-controls [directionLinks]="true"
                             [previousLabel]="''"
                             [nextLabel]="''"
                             [autoHide]="true"
                             (pageChange)="onPageChanged($event)"></pagination-controls>
    </div>
</ng-template>
